import { render } from "./ScheduleAppointment.vue?vue&type=template&id=cef2d08c"
import script from "./ScheduleAppointment.vue?vue&type=script&lang=js"
export * from "./ScheduleAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__